// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"UserModal_btn-primary__2Dzdw","button":"UserModal_button__2Frua","form-input":"UserModal_form-input__XOXIp","input":"UserModal_input__O8gaE"};